export default __webpack_public_path__ + "img/img_ahikaa-fa445f6d4f7e64fe5b9a89dde014525f.jpg";